import {
  sortByEventStartDefault,
  sortByPublicationDateTimeDefault,
} from 'src/pages/market-messages/urgent-market-messages/overview/use-page-params';

export function mapOldUmmSearchParams(
  searchParams: URLSearchParams
): URLSearchParams {
  let searchString = decodeURIComponent(searchParams.toString());

  searchString = searchString
    .replace(/publicationDateTimeStart=/g, 'publicationDateTimeFrom=')
    .replace(/publicationDateTimeStop=/g, 'publicationDateTimeTo=')
    .replace(/eventStart=/g, 'eventPeriodFrom=')
    .replace(/eventStop=/g, 'eventPeriodTo=')
    .replace(/sortBy=eventStart/g, `sortBy=${sortByEventStartDefault}`)
    .replace(
      /sortBy=publicationDateTime/g,
      `sortBy=${sortByPublicationDateTimeDefault}`
    )
    .replace(
      /UNAVAILABILITIES_OF_GAS_FACILITIES/g,
      'UNAVAILABILITY_OF_GAS_FACILITIES'
    );

  // filter out any marketParticipants parameters
  const newParams = new URLSearchParams(searchString);
  const keysToDelete: string[] = [];

  newParams.forEach((_, key) => {
    if (key.startsWith('marketParticipants')) {
      keysToDelete.push(key);
    }
  });

  keysToDelete.forEach((key) => {
    newParams.delete(key);
  });

  return newParams;
}
